<script setup>
  import {BriefcaseIcon, HeartIcon} from "@heroicons/vue/16/solid";

  const props = defineProps({
    contributors: {
      type: Object,
      default: () => {},
    }
  }),
  calculatePercentage = (total, value) => value / total * 100;
</script>

<template>
  <div class="">
    <div
      v-for="(contributor, index) in props.contributors.items"
      :key="index"
      :class="['flex items-center mb-4', index === 0 ? 'mt-4': '']"
    >
      <span>
        <router-link
          :to="`/users/${ contributor.id }/businesses`"
          class="card-link"
          data-toggle="tooltip"
          :data-title="`${ contributor.name }`"
        >
          <img
            :src="contributor.profile.avatar"
            :alt="contributor.name"
            class="rounded shadow-lg rounded-xl"
            width="130px"
            style="height:96px"
          >
        </router-link>
      </span>
      <div class="w-full ml-2 bg-white rounded-xl p-4">
        <span class="block text-left text-sm text-gray-500 font-semibold">{{ contributor.name }}</span>
        <div class="flex items-center w-full">
          <div class="w-full bg-green-200 rounded-full h-1.5 dark:bg-green-200">
            <div
              aria-describedby="posts count"
              role="progressbar"
              :aria-valuenow="{ width: calculatePercentage(props.contributors.postsCount, contributor.postCount) + '%'}"
              aria-valuemin="0"
              aria-valuemax="100"
              class="bg-green-400 h-1.5 rounded-full"
              :style="{ width: calculatePercentage(props.contributors.postsCount, contributor.postCount) + '%'}"
            />
          </div>
          <span class="text-xs text-gray-400 font-semibold ml-2">{{ contributor.postCount }}</span>
          <BriefcaseIcon
            class="text-yellow-500 cursor-pointer ml-2 h-5"
            :aria-hidden="false"
          />
        </div>
        <div class="flex items-center w-full">
          <div class="w-full bg-red-200 rounded-full h-1.5 dark:bg-red-200">
            <div
              aria-describedby="likes count"
              role="progressbar"
              :aria-valuenow="{ width: calculatePercentage(props.contributors.likesCount, contributor.likeReceivedCount) + '%'}"
              aria-valuemin="0"
              aria-valuemax="100"
              class="bg-red-400 h-1.5 rounded-full"
              :style="{ width: calculatePercentage(props.contributors.likesCount, contributor.likeReceivedCount) + '%'}"
            />
          </div>
          <span class="text-xs text-gray-400 font-semibold ml-2">{{ contributor.likeReceivedCount }}</span>
          <HeartIcon
            class="text-yellow-500 cursor-pointer ml-1 h-6"
            :aria-hidden="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
